export default __webpack_public_path__ + "static/media/destroyed-tires-template.fdd9bd6e.xlsx";